<script>
export default {
  data() {
    return {
      assignedFields: [],
      selectedField: null
    };
  },
  methods: {
    addField(field) {
      field = _.cloneDeep(field);
      if (!this.selectedField) {
        this.assignedFields.push(field);
      } else {
        let fields = this.assignedFields;
        this.assignedFields = [];
        this.assignedFields = fields.map(f => {
          return f.id == this.selectedField.id ? field : f;
        });
        this.selectedField = null;
      }
      if ($(".field-list").length > 0) {
        $("html,body").animate(
          { scrollTop: $(".field-list").offset().top - 100 },
          400
        );
      }
    },
    editField(field) {
      let selected = Object.assign({}, field);
      this.selectedField = {};
      this.selectedField = selected;
      console.log(this.selectedField);
      $("html,body").animate({ scrollTop: 0 }, 400);
    },
    removeField(index) {
      this.assignedFields.splice(index, 1);
    }
  }
};
</script>